module.exports = __webpack_public_path__ + "static/media/temp-tutorialItem-img.54f25f62.png";